import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortalDirective} from "@angular/cdk/portal";

@Directive({
  selector: '[table-column-label]'
})
export class TableColumnLabelDirective extends TemplatePortalDirective {

  constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/data-table/table-column-label.directive.ts